import { render, staticRenderFns } from "./AppSplitter.vue?vue&type=template&id=2fa78eca"
import script from "./AppSplitter.vue?vue&type=script&lang=js"
export * from "./AppSplitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSplitter});
